import Navbar from "./components/layout/Navbar";
import Router from "./router";

function App() {
  return (
    <>
      <Navbar />
      <Router />
    </>
  );
}

export default App;
